import React from 'react';
import { ChatPanel } from '../../components/AgentChat/ChatPanel';
import './styles.css';

const AgentChat: React.FC = () => {
  return (
    <div className="agent-page">
      <div className="agent-page-bg" aria-hidden="true" />
      <div className="agent-page-inner">
        <ChatPanel />
      </div>
    </div>
  );
};

export default AgentChat;
